#import "../fragments/dromo-import-fragment.graphql"

mutation RevertDromoImport($input: DromoImportRollbackInput!) {
    dromoImportRollback(input: $input) {
        import {
            ...DromoImportFragment
        }
    }
}
